import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UpdateCurrentUser, CurrentUser, ChangePassword, UserSummary, UpdateUser, User, RegisterUser } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl = `${environment.apiUrl}/users`;

  constructor(private http: HttpClient) {}

  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.baseUrl}/me`);
  }

  saveCurrentUser(currentUser: UpdateCurrentUser): Observable<void> {
      return this.http.put<void>(`${this.baseUrl}/me`, currentUser);
  }

  changePassword(changePasswordData: ChangePassword): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/password`, changePasswordData);
  }

  getUser(id: string): Observable<User> {
    return this.http.get<User>(`${this.baseUrl}/${id}`);
  }

  getUsers(): Observable<UserSummary[]> {
    return this.http.get<UserSummary[]>(this.baseUrl);
  }

  registerUser(registerUser: RegisterUser): Observable<void> {
    return this.http.post<void>(this.baseUrl, registerUser);
  }

  updateUser(updateUser: UpdateUser): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${updateUser.id}`, updateUser);
  }

  deleteUser(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

}